<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3">Print PDF</h3>
      <iframe
        :src="pdf_to_print"
        id="myFrame"
        frameborder="0"
        style="display: none;"
        width="300"
        height="300"
      >
      </iframe>

      <hr />

      <b-card class="mb-1">
        <div style="width: 70%">
          <b-row>
            <b-col cols="2">
              <strong>Tracking #</strong>
            </b-col>
            <b-col cols="3">
              <b-form-input
                ref="txt_tracking_number"
                size="sm"
                type="text"
                placeholder
                v-model="tracking_search.tracking_number"
                v-on:keyup.enter="onSearch()"
              ></b-form-input>
            </b-col>
            <b-col cols="3" class="text-left p-0">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="onSearch"
              >
                Submit
              </b-button>

              <!-- <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="onSearch"
              >
                <font-awesome-icon class="mr-1" icon="camera" />
              </b-button> -->
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

export default {
  name: "RedemptionCenter",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      pdf_to_print: false,
      order_master: false,
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Order Master",
          to: { name: "Order Master" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      process_mode_options: [
        {
          text: "Simple",
          value: "simple"
        },
        {
          text: "Advanced",
          value: "advanced"
        }
      ],
      process_mode: "advanced",
      tracking_search: {},
      loader: false,
      order_master_products: [],
      fulfil_products: [{}],
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      total_item_qty: 0,
      fulfil_obj: {
        total_item_qty: 0,
        total_weight: 0,
        no_of_cartons: 1,
        actual_total_weight: null,
        packed_by_vendor: null,
        actual_size_height: null,
        actual_size_width: null,
        actual_size_depth: null
      },
      tracking_obj: false,
      fulfil_orders: [
        {
          order_cartons: 1
        }
      ]
    };
  },
  async created() {
    // await this.getOrderMasterDetail();
    // await this.getOrderMasterProduct();
    this.initialized = true;
    if (
      this.$store.state.user_obj.client_id == "20" ||
      this.$store.state.user_obj.client_id == "23"
    ) {
      this.fulfil_obj.packed_by_vendor = 1;
    }
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      // RMW
      if(true || this.$store.state.user_obj.client_id == '11'){
        this.tracking_search.tracking_number =
            this.tracking_search.tracking_number.replace(/^0+/, "");
            
        this.tracking_obj = {
          tracking_number : this.tracking_search.tracking_number
        };
        
        await this.printPdf();

        return;
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "fulfilment_process_info_get.php",
        data: {
          tracking_number: this.tracking_search.tracking_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      console.log(response.data.tracking);

      if (response.data.tracking && response.data.tracking.tracking_number) {
        this.tracking_obj = response.data.tracking;
        
        await this.printPdf();

        this.loader.hide();
        this.tracking_search = {};
        this.tracking_obj = false;
        this.$refs["txt_tracking_number"].$el.focus();

        

      } else {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Invalid Order Number",
          variant: "danger"
        });
        this.loader.hide();
        this.tracking_search = {};
        this.tracking_obj = false;
        this.$refs["txt_tracking_number"].$el.focus();
      }
    },

    async searchOrder() {
      // await this.getOrderMasterDetail();
      await this.getFulfilmentProcessInfo();
      await this.getOrderMasterProduct();
    },

    async printPdf() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_log_print_pdf.php",
        data: {
          tracking_number: this.tracking_search.tracking_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      let self = this;
      // this.pdf_to_print =
      //   "https://tracking.gols.com.hk/waybill_file/GOLS_PDF/" +
      //   this.tracking_obj.tracking_number +
      //   ".pdf";
      
      let pdf_to_print_src = encodeURIComponent('GOLS_PDF' +
        "/" +
        this.tracking_obj.tracking_number);
        this.pdf_to_print = "https://sys.gols.com.hk/api/download_ftp_waybill.php?url="+pdf_to_print_src;

      setTimeout(() => {
        let objFra = document.getElementById("myFrame");
        objFra.contentWindow.focus();
        objFra.contentWindow.print();
      }, 4000);

      let tracking_number = this.tracking_search.tracking_number;

      setTimeout(() => {
        self.loader.hide();

        fetch(self.pdf_to_print).then(function(t) {
          return t.blob().then(b => {
            var a = document.createElement("a");
            a.href = URL.createObjectURL(b);
            // a.setAttribute("download", self.pdf_to_print.split("/").pop());
            a.setAttribute("download", tracking_number+".pdf");
            a.click();
          });
        });

        self.tracking_search = {};
        self.tracking_obj = false;
        this.$refs["txt_tracking_number"].$el.focus();
      }, 6000);

      await sleep(6000);

      this.loader.hide();
      this.tracking_search = {};
      this.tracking_obj = false;
      this.$refs["txt_tracking_number"].$el.focus();
    }
  },
  sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
};
</script>


<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PrintPdfPortal.vue